// extracted by mini-css-extract-plugin
export var container = "ErrorMessage_container__XVn0p";